module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hideme"
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "perPageCustom": [
        [480, 1],
        [768, 1]
      ],
      "paginationPadding": 10
    }
  }, _vm._l((_vm.sliderContent), function(slide, idx) {
    return _c('slide', {
      key: idx
    }, [_c('div', {
      staticClass: "VueCarousel-slide"
    }, [_c('img', {
      attrs: {
        "src": _vm.exportImagePath(slide.image),
        "width": "100%",
        "alt": "Three Billboards"
      }
    })])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3ea768c","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderImage.vue
// module id = 239
// module chunks = 0